"use client";

import React, { useState, useEffect } from "react";
import LabelInput from "../label";

//Style
import * as S from "./styles";

type Option = {
  value: string;
  label: string;
};

type SmartMultiSelectProps = {
  options: Option[];
  placeholder: string;
  label: string;
  name: string;
  setValue: (
    name: any,
    value: any,
    options?: { shouldValidate?: boolean },
  ) => void;
  getValues: (name: string) => any;
};

const SmartMultiSelect: React.FC<SmartMultiSelectProps> = ({
  options,
  placeholder,
  label,
  name,
  setValue,
  getValues,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);
  const [search, setSearch] = useState("");

  // Inicializa os valores selecionados com base no form
  useEffect(() => {
    const formValues = getValues(name);
    if (Array.isArray(formValues)) {
      const initialSelected = options.filter((opt) =>
        formValues.includes(opt.value),
      );
      setSelectedOptions(initialSelected);
    }
  }, [name, getValues, options]);

  // Função para atualizar o form sempre que houver mudança
  const updateFormValue = (newSelected: Option[]) => {
    setSelectedOptions(newSelected);
    setValue(
      name,
      newSelected.map((opt) => opt.value),
      { shouldValidate: true },
    );
  };

  const availableOptions = options.filter(
    (opt) =>
      !selectedOptions.some((sel) => sel.value === opt.value) &&
      opt.label.toLowerCase().includes(search.toLowerCase()),
  );

  const handleSelect = (option: Option) => {
    const updated = [...selectedOptions, option];
    updateFormValue(updated);
    setSearch("");
  };

  const handleRemove = (valueToRemove: string) => {
    const updated = selectedOptions.filter(
      (opt) => opt.value !== valueToRemove,
    );
    updateFormValue(updated);
  };

  return (
    <S.BoxMutiple>
      <LabelInput labelInput={label} />

      <S.InputSearch
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder={placeholder}
      />

      {availableOptions.length > 0 && (
        <S.ListSelect>
          {availableOptions.map((option) => (
            <S.ListSelectItem
              key={option.value}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </S.ListSelectItem>
          ))}
        </S.ListSelect>
      )}

      <S.BoxListSelect
        style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
      >
        {selectedOptions.map((opt) => (
          <S.ButtonSelect key={opt.value}>
            {opt.label}
            <S.ButtonClose onClick={() => handleRemove(opt.value)}>
              x
            </S.ButtonClose>
          </S.ButtonSelect>
        ))}
      </S.BoxListSelect>
    </S.BoxMutiple>
  );
};

export default SmartMultiSelect;
